import { Control } from 'react-hook-form';
import {
  CreateAPITestPlanInput,
  Environment,
  APITestPlanSorting,
  GoldStandardTestSetSelection,
  skusByProviderQuery,
} from '~/src/generated/portal/graphql';

// SKU Box State Types
export type SkuBoxState = {
  formValues: any;
  enableAllSets: boolean;
  hasError: boolean;
  errorMessage: string;
};

export type SkuBoxStates = Record<string, SkuBoxState>;

// Form Types
export type TCreateTestPlanForm = CreateAPITestPlanInput & {
  planType: 'auto' | 'manual';
  skuValue?: string | { label: string; value: string; key: string; isGeneric: boolean };
  [key: string]: any;
  globalTestSets?: [GoldStandardTestSetSelection] | [];
};

// Component Props
export interface TestPlanActionsModalProps {
  name?: string;
  description?: string;
  providerId?: string;
  platform?: string;
  environment?: Environment;
  partnerId: string;
  action: string;
  sortBy?: APITestPlanSorting;
  id?: string;
  minApiVersion?: string;
  onNewTestPlanComplete?: (str: string) => void;
}

export interface TestSetsTabProps {
  selectedValue: number;
  onClick: React.Dispatch<React.SetStateAction<number>>;
  control: Control<TCreateTestPlanForm>;
  enabled?: boolean;
  goldStandardFormValues?: any;
  hasSkuValue?: boolean;
  goldStandardError?: boolean;
  skuBoxStates?: SkuBoxStates;
  additionalSkuBoxes?: number[];
}

export interface SkuBoxProps {
  skuId: number;
  skuFieldName: string;
  control: any;
  watch: any;
  data: skusByProviderQuery | undefined;
  skuBoxStates: SkuBoxStates;
  setSkuBoxStates: React.Dispatch<React.SetStateAction<SkuBoxStates>>;
  goldStandardFormValues?: any;
  setGoldStandardFormValues?: React.Dispatch<React.SetStateAction<any>>;
  enableAllSets?: boolean;
  setEnableAllSets?: React.Dispatch<React.SetStateAction<boolean>>;
  goldStandardError?: boolean;
  setGoldStandardError?: React.Dispatch<React.SetStateAction<boolean>>;
  allSkuBoxes?: number[];
  onRemove?: (skuId: number) => void;
  activeBoxId?: string | null;
  setActiveBoxId?: (id: string | null) => void;
  collapsedState?: Record<string, boolean>;
  setCollapsedState?: (state: Record<string, boolean>) => void;
  onUserInteraction?: () => void;
  loadingSkus?: boolean;
}

export const TOGGLE_LABELS: Record<string, string> = {
  purchaseActivationCancellation: 'Purchase, Activation & Cancellation',
  resubscription: 'Resubscription',
  bundleBillingHold: 'Bundle Billing Hold',
  gracePeriod: 'Grace Period',
  offerTransitions: 'Offer Transitions',
  tierDowngrade: 'Tier Downgrade',
  tierUpgrade: 'Tier Upgrade',
};

export const createDefaultValues = (
  partnerId: string,
  name?: string,
  description?: string,
  providerId?: string,
  platform?: string,
  environment?: Environment,
  minApiVersion?: string,
): TCreateTestPlanForm => ({
  name: name ? `${name} Copy` : '',
  description: description || '',
  partnerId: partnerId,
  providerId: providerId || '',
  platform: platform || '',
  environment: environment || Environment.QA,
  testSetIds: [],
  minApiVersion: minApiVersion || '',
  planType: 'auto',
  skuValue: '',
  globalTestSets: [],
  reconciliation: false,
});
